module.exports = __webpack_public_path__ + "src/assets/custom_map_marker.svg";